/* 5th Avenue room planner: canonical dimensions are inches; x/y are item centers. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FAFRoomPlannerCore = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var EPS = 1e-7;
  var MAX_JSON = 150000;
  var KINDS = ['sofa', 'sectional', 'bed', 'table', 'chair', 'storage', 'rug', 'door', 'window', 'obstacle'];
  var SHAPES = ['rect', 'ellipse', 'sectional-left', 'sectional-right', 'sectional-u'];
  var SOURCES = ['placeholder', 'customer', 'catalog'];
  var presets = [
    { key: 'blank', label: 'Blank room', description: 'Start with an empty rectangular room.' },
    { key: 'living', label: 'Living room', description: 'Generic furniture sizes you can change.' },
    { key: 'bedroom', label: 'Bedroom', description: 'A bed, nightstands, and storage with editable sizes.' },
    { key: 'dining', label: 'Dining room', description: 'A table and chairs with editable sizes.' },
    { key: 'lshape', label: 'L-shaped room', description: 'An editable room with a top-right cutout.' }
  ];
  // These are editable generic placeholders, never dimensions inferred for real products.
  var catalog = [
    { key: 'sofa', label: 'Sofa', kind: 'sofa', shape: 'rect', width: 84, depth: 36, color: '#7b8b86' },
    { key: 'loveseat', label: 'Loveseat', kind: 'sofa', shape: 'rect', width: 60, depth: 36, color: '#7b8b86' },
    { key: 'sectional-left', label: 'Left chaise sectional', kind: 'sectional', shape: 'sectional-left', width: 108, depth: 72, armDepth: 36, color: '#7b8b86' },
    { key: 'sectional-right', label: 'Right chaise sectional', kind: 'sectional', shape: 'sectional-right', width: 108, depth: 72, armDepth: 36, color: '#7b8b86' },
    { key: 'sectional-u', label: 'U-shaped sectional', kind: 'sectional', shape: 'sectional-u', width: 132, depth: 84, armDepth: 36, color: '#7b8b86' },
    { key: 'chair', label: 'Accent chair', kind: 'chair', shape: 'rect', width: 32, depth: 34, color: '#b59076' },
    { key: 'recliner', label: 'Recliner (closed)', kind: 'chair', shape: 'rect', width: 40, depth: 40, color: '#b59076' },
    { key: 'ottoman', label: 'Ottoman', kind: 'chair', shape: 'rect', width: 28, depth: 24, color: '#b59076' },
    { key: 'bench', label: 'Bench', kind: 'sofa', shape: 'rect', width: 60, depth: 18, color: '#b59076' },
    { key: 'coffee-table', label: 'Coffee table', kind: 'table', shape: 'rect', width: 48, depth: 24, color: '#aa8966' },
    { key: 'round-table', label: 'Round table', kind: 'table', shape: 'ellipse', width: 42, depth: 42, color: '#aa8966' },
    { key: 'dining-table', label: 'Dining table', kind: 'table', shape: 'rect', width: 72, depth: 40, color: '#aa8966' },
    { key: 'desk', label: 'Desk', kind: 'table', shape: 'rect', width: 60, depth: 28, color: '#aa8966' },
    { key: 'dining-chair', label: 'Dining chair', kind: 'chair', shape: 'rect', width: 20, depth: 22, color: '#b59076' },
    { key: 'bed', label: 'Bed frame', kind: 'bed', shape: 'rect', width: 64, depth: 86, color: '#969aac' },
    { key: 'nightstand', label: 'Nightstand', kind: 'storage', shape: 'rect', width: 24, depth: 18, color: '#aa8966' },
    { key: 'dresser', label: 'Dresser', kind: 'storage', shape: 'rect', width: 60, depth: 18, color: '#aa8966' },
    { key: 'tv-console', label: 'TV console', kind: 'storage', shape: 'rect', width: 72, depth: 18, color: '#aa8966' },
    { key: 'bookcase', label: 'Bookcase', kind: 'storage', shape: 'rect', width: 36, depth: 14, color: '#aa8966' },
    { key: 'rug', label: 'Area rug', kind: 'rug', shape: 'rect', width: 96, depth: 120, color: '#d9cbb2' },
    { key: 'door', label: 'Door swing', kind: 'door', shape: 'rect', width: 36, depth: 36, color: '#b28a62' },
    { key: 'window', label: 'Window', kind: 'window', shape: 'rect', width: 48, depth: 4, color: '#a8cbd4' },
    { key: 'obstacle', label: 'Column or obstacle', kind: 'obstacle', shape: 'rect', width: 18, depth: 18, color: '#8d8580' }
  ];
  function fail(message) { throw new Error(message); }
  function object(value, field) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) fail(field + ' must be an object.');
    var proto = Object.getPrototypeOf(value);
    if (proto !== Object.prototype && proto !== null) fail(field + ' must be a plain object.');
    return value;
  }
  function number(value, min, max, field) {
    if (typeof value !== 'number' || !Number.isFinite(value) || value < min || value > max) fail(field + ' must be a number between ' + min + ' and ' + max + '.');
    return Object.is(value, -0) ? 0 : value;
  }
  function choice(value, options, field) {
    if (options.indexOf(value) < 0) fail('Unsupported ' + field + '.');
    return value;
  }
  function text(value, fallback, field, max) {
    if (value === undefined) value = fallback;
    if (typeof value !== 'string' || value.length > (max || 80)) fail(field + ' must be text of at most ' + (max || 80) + ' characters.');
    return value.replace(/[\u0000-\u001f\u007f<>]/g, '').trim() || fallback;
  }
  function clone(value) { return JSON.parse(JSON.stringify(value)); }
  function uid() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return 'item-' + crypto.randomUUID();
    return 'item-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }
  function productId(value, type, required) {
    if (value === undefined && !required) return undefined;
    if (typeof value === 'number') {
      if (!Number.isSafeInteger(value) || value <= 0) fail('Invalid ' + type + ' ID.');
      value = String(value);
    }
    if (typeof value !== 'string') fail('Invalid ' + type + ' ID.');
    var gid = new RegExp('^gid://shopify/' + type + '/([1-9][0-9]{0,19})$').exec(value);
    if (gid) value = gid[1];
    if (!/^[1-9][0-9]{0,19}$/.test(value)) fail('Invalid ' + type + ' ID.');
    return value;
  }
  function validateProduct(value) {
    object(value, 'Product');
    if (typeof value.handle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,199}$/.test(value.handle)) fail('Invalid product handle.');
    var result = { handle: value.handle, variantId: productId(value.variantId, 'ProductVariant', true) };
    if (value.productId !== undefined) result.productId = productId(value.productId, 'Product', false);
    if (value.sku !== undefined) result.sku = text(value.sku, '', 'SKU', 100);
    return result;
  }
  function validatePlan(input) {
    object(input, 'Plan');
    if (input.version !== 1) fail('This plan version is not supported.');
    var room = object(input.room, 'Room');
    var result = {
      version: 1,
      name: text(input.name, 'My room plan', 'Plan name'),
      unit: choice(input.unit, ['in', 'cm'], 'measurement unit'),
      room: {
        shape: choice(room.shape, ['rectangle', 'l-shape'], 'room shape'),
        width: number(room.width, 24, 1200, 'Room width'),
        depth: number(room.depth, 24, 1200, 'Room depth'),
        cutWidth: 0,
        cutDepth: 0
      },
      items: []
    };
    if (result.room.shape === 'l-shape') {
      result.room.cutWidth = number(room.cutWidth, 1, result.room.width - 12, 'Cutout width');
      result.room.cutDepth = number(room.cutDepth, 1, result.room.depth - 12, 'Cutout depth');
    }
    if (!Array.isArray(input.items) || input.items.length > 80) fail('A plan can contain at most 80 items.');
    var ids = Object.create(null);
    result.items = input.items.map(function (raw) {
      object(raw, 'Furniture item');
      if (typeof raw.id !== 'string' || !/^[a-zA-Z0-9_-]{1,80}$/.test(raw.id) || ids[raw.id]) fail('Each item needs a unique valid ID.');
      ids[raw.id] = true;
      var item = {
        id: raw.id,
        kind: choice(raw.kind, KINDS, 'item kind'),
        label: text(raw.label, 'Furniture', 'Item label'),
        x: number(raw.x, -1200, 2400, 'Item position'),
        y: number(raw.y, -1200, 2400, 'Item position'),
        width: number(raw.width, 1, 600, 'Item width'),
        depth: number(raw.depth, 1, 600, 'Item depth'),
        rotation: ((number(raw.rotation === undefined ? 0 : raw.rotation, -360000, 360000, 'Rotation') % 360) + 360) % 360,
        color: raw.color === undefined ? '#9b968b' : raw.color,
        shape: choice(raw.shape || 'rect', SHAPES, 'item shape'),
        clearance: number(raw.clearance === undefined ? 0 : raw.clearance, 0, 120, 'Clearance'),
        source: choice(raw.source || 'placeholder', SOURCES, 'measurement source')
      };
      if (typeof item.color !== 'string' || !/^#[0-9a-fA-F]{6}$/.test(item.color)) fail('Item colors must be six-digit hex colors.');
      if (item.shape.indexOf('sectional-') === 0) {
        item.armDepth = number(raw.armDepth === undefined ? Math.min(item.width, item.depth) / 3 : raw.armDepth, 1, Math.min(item.width, item.depth) - 0.01, 'Sectional seat depth');
        if (item.shape === 'sectional-u' && item.armDepth * 2 >= item.width) fail('U-shaped seating needs space between its arms.');
      }
      if (item.kind === 'door' && Math.abs(item.width - item.depth) > EPS) fail('Door swing width and depth must be equal.');
      if (raw.product !== undefined) item.product = validateProduct(raw.product);
      if (item.source === 'catalog' && !item.product) fail('Catalog furniture must identify its product and variant.');
      return item;
    });
    return result;
  }
  function serialize(plan) { return JSON.stringify(validatePlan(plan)); }
  function deserialize(json) {
    if (typeof json !== 'string' || json.length > MAX_JSON) fail('This plan file is too large or is not text.');
    var value;
    try { value = JSON.parse(json); } catch (_) { fail('This file is not valid plan JSON.'); }
    return validatePlan(value);
  }
  function toDisplay(inches, unit) {
    number(inches, -1000000, 1000000, 'Measurement');
    choice(unit, ['in', 'cm'], 'measurement unit');
    return unit === 'cm' ? inches * 2.54 : inches;
  }
  function fraction(value) {
    var match = /^(?:(\d+)\s+)?(\d+)\/(\d+)$/.exec(value);
    if (match) {
      var denom = Number(match[3]);
      if (!denom || denom > 1000000) fail('Invalid inch fraction.');
      return Number(match[1] || 0) + Number(match[2]) / denom;
    }
    if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) fail('Enter a valid measurement.');
    return Number(value);
  }
  function fromDisplay(value, unit) {
    choice(unit, ['in', 'cm'], 'measurement unit');
    var result;
    if (typeof value === 'number') result = value;
    else if (typeof value === 'string' && value.length <= 80) {
      var input = value.trim().toLowerCase();
      if (unit === 'cm') {
        if (!/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(input)) fail('Enter a number in centimeters.');
        result = Number(input);
      } else {
        var sign = input.charAt(0) === '-' ? -1 : 1;
        if (sign < 0) input = input.slice(1);
        input = input.replace(/feet|foot|ft|′/g, "'").replace(/inches|inch|in|″/g, '"').trim();
        var feet = /^(\d+(?:\.\d+)?)\s*'\s*(.*?)\s*"?$/.exec(input);
        result = feet ? Number(feet[1]) * 12 + (feet[2] ? fraction(feet[2]) : 0) : fraction(input.replace(/"$/, '').trim());
        result *= sign;
      }
    } else fail('Enter a valid measurement.');
    number(result, -1000000, 1000000, 'Measurement');
    return unit === 'cm' ? result / 2.54 : result;
  }
  function format(inches, unit) {
    var value = toDisplay(inches, unit);
    if (unit === 'cm') return (Math.round(value * 10) / 10).toLocaleString('en-US') + ' cm';
    var sign = value < 0 ? '-' : '';
    var eighths = Math.round(Math.abs(value) * 8);
    var feet = Math.floor(eighths / 96);
    var remaining = eighths % 96;
    var whole = Math.floor(remaining / 8);
    var fractions = ['', '1/8', '1/4', '3/8', '1/2', '5/8', '3/4', '7/8'];
    return sign + (feet ? feet + "' " : '') + whole + (remaining % 8 ? ' ' + fractions[remaining % 8] : '') + '"';
  }
  function roomPolygon(room) {
    var w = room.width, d = room.depth;
    return room.shape === 'l-shape' ? [
      { x: 0, y: 0 }, { x: w - room.cutWidth, y: 0 },
      { x: w - room.cutWidth, y: room.cutDepth }, { x: w, y: room.cutDepth },
      { x: w, y: d }, { x: 0, y: d }
    ] : [{ x: 0, y: 0 }, { x: w, y: 0 }, { x: w, y: d }, { x: 0, y: d }];
  }
  function rect(x, y, w, d) { return [{ x: x, y: y }, { x: x + w, y: y }, { x: x + w, y: y + d }, { x: x, y: y + d }]; }
  function itemPolygons(item) {
    var w = item.width, d = item.depth, left = -w / 2, top = -d / 2;
    var polygons = [], points = [], i;
    if (item.kind === 'door') {
      // Approximate the entire 90-degree swing area, not just the leaf. Hinge is local top-left.
      points.push({ x: left, y: top });
      for (i = 0; i <= 24; i++) {
        var angle = i * Math.PI / 48;
        points.push({ x: left + w * Math.cos(angle), y: top + d * Math.sin(angle) });
      }
      polygons.push(points);
    } else if (item.shape === 'ellipse') {
      for (i = 0; i < 64; i++) {
        var radians = i * Math.PI * 2 / 64;
        points.push({ x: w * Math.cos(radians) / 2, y: d * Math.sin(radians) / 2 });
      }
      polygons.push(points);
    } else if ((item.shape || '').indexOf('sectional-') === 0) {
      var arm = item.armDepth || Math.min(w, d) / 3;
      polygons.push(rect(left, top, w, arm));
      if (item.shape === 'sectional-left' || item.shape === 'sectional-u') polygons.push(rect(left, top + arm, arm, d - arm));
      if (item.shape === 'sectional-right' || item.shape === 'sectional-u') polygons.push(rect(left + w - arm, top + arm, arm, d - arm));
    } else polygons.push(rect(left, top, w, d));
    var rotation = (item.rotation || 0) * Math.PI / 180, cos = Math.cos(rotation), sin = Math.sin(rotation);
    return polygons.map(function (poly) { return poly.map(function (p) { return { x: item.x + p.x * cos - p.y * sin, y: item.y + p.x * sin + p.y * cos }; }); });
  }
  function cross(ax, ay, bx, by) { return ax * by - ay * bx; }
  function onSegment(p, a, b) {
    var length = Math.hypot(b.x - a.x, b.y - a.y);
    if (Math.abs(cross(p.x - a.x, p.y - a.y, b.x - a.x, b.y - a.y)) > EPS * Math.max(1, length)) return false;
    return p.x >= Math.min(a.x, b.x) - EPS && p.x <= Math.max(a.x, b.x) + EPS && p.y >= Math.min(a.y, b.y) - EPS && p.y <= Math.max(a.y, b.y) + EPS;
  }
  function inside(p, polygon) {
    var inPolygon = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      var a = polygon[j], b = polygon[i];
      if (onSegment(p, a, b)) return true;
      if ((a.y > p.y) !== (b.y > p.y) && p.x < (b.x - a.x) * (p.y - a.y) / (b.y - a.y) + a.x) inPolygon = !inPolygon;
    }
    return inPolygon;
  }
  function edgeInside(a, b, room) {
    var cuts = [0, 1], dx = b.x - a.x, dy = b.y - a.y;
    for (var i = 0; i < room.length; i++) {
      var c = room[i], d = room[(i + 1) % room.length];
      var ex = d.x - c.x, ey = d.y - c.y, denominator = cross(dx, dy, ex, ey);
      if (Math.abs(denominator) <= EPS) continue;
      var t = cross(c.x - a.x, c.y - a.y, ex, ey) / denominator;
      var u = cross(c.x - a.x, c.y - a.y, dx, dy) / denominator;
      if (t > EPS && t < 1 - EPS && u >= -EPS && u <= 1 + EPS) cuts.push(t);
    }
    cuts.sort(function (x, y) { return x - y; });
    for (var n = 1; n < cuts.length; n++) {
      var mid = (cuts[n - 1] + cuts[n]) / 2;
      if (!inside({ x: a.x + dx * mid, y: a.y + dy * mid }, room)) return false;
    }
    return true;
  }
  function contained(poly, room) {
    return poly.every(function (point, i) { return inside(point, room) && edgeInside(point, poly[(i + 1) % poly.length], room); });
  }
  function bounds(polygons) {
    var box = { minX: Infinity, minY: Infinity, maxX: -Infinity, maxY: -Infinity };
    polygons.forEach(function (poly) { poly.forEach(function (p) { box.minX = Math.min(box.minX, p.x); box.maxX = Math.max(box.maxX, p.x); box.minY = Math.min(box.minY, p.y); box.maxY = Math.max(box.maxY, p.y); }); });
    return box;
  }
  function boxDistance(a, b) { return Math.hypot(Math.max(0, a.minX - b.maxX, b.minX - a.maxX), Math.max(0, a.minY - b.maxY, b.minY - a.maxY)); }
  function intersects(a, b) {
    var polygons = [a, b];
    for (var p = 0; p < polygons.length; p++) {
      var poly = polygons[p];
      for (var i = 0; i < poly.length; i++) {
        var next = poly[(i + 1) % poly.length], dx = next.x - poly[i].x, dy = next.y - poly[i].y;
        var length = Math.hypot(dx, dy);
        if (length <= EPS) continue;
        var nx = -dy / length, ny = dx / length;
        var amin = Infinity, amax = -Infinity, bmin = Infinity, bmax = -Infinity;
        a.forEach(function (v) { var projection = v.x * nx + v.y * ny; amin = Math.min(amin, projection); amax = Math.max(amax, projection); });
        b.forEach(function (v) { var projection = v.x * nx + v.y * ny; bmin = Math.min(bmin, projection); bmax = Math.max(bmax, projection); });
        if (Math.min(amax, bmax) - Math.max(amin, bmin) <= EPS) return false;
      }
    }
    return true;
  }
  function pointSegmentDistance(p, a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, squared = dx * dx + dy * dy;
    var t = squared ? Math.max(0, Math.min(1, ((p.x - a.x) * dx + (p.y - a.y) * dy) / squared)) : 0;
    return Math.hypot(p.x - a.x - t * dx, p.y - a.y - t * dy);
  }
  function polygonDistance(a, b) {
    var distance = Infinity;
    [a, b].forEach(function (poly, index) {
      var other = index ? a : b;
      poly.forEach(function (point) { other.forEach(function (start, i) { distance = Math.min(distance, pointSegmentDistance(point, start, other[(i + 1) % other.length])); }); });
    });
    return distance;
  }
  function analyze(input) {
    var plan = validatePlan(input), room = roomPolygon(plan.room), warnings = [];
    var data = plan.items.map(function (item) {
      var polygons = itemPolygons(item);
      if (item.kind !== 'window' && !polygons.every(function (poly) { return contained(poly, room); })) warnings.push({ type: 'outside', itemId: item.id, message: item.label + ' extends outside the room.' });
      return { item: item, polygons: polygons, box: bounds(polygons) };
    });
    for (var i = 0; i < data.length; i++) {
      for (var j = i + 1; j < data.length; j++) {
        var first = data[i], second = data[j], a = first.item, b = second.item;
        if (a.kind === 'window' || b.kind === 'window') continue;
        if ((a.kind === 'rug' && b.kind !== 'obstacle' && b.kind !== 'door') || (b.kind === 'rug' && a.kind !== 'obstacle' && a.kind !== 'door')) continue;
        var clearance = Math.max(a.clearance, b.clearance);
        var gap = boxDistance(first.box, second.box);
        if (gap > EPS && gap >= clearance - EPS) continue;
        var overlap = first.polygons.some(function (ap) { return second.polygons.some(function (bp) { return intersects(ap, bp); }); });
        if (overlap) {
          var door = a.kind === 'door' ? a : b.kind === 'door' ? b : null;
          var other = door === a ? b : a;
          warnings.push(door ? { type: 'door', itemId: door.id, otherId: other.id, message: other.label + ' overlaps the approximate full swing area of ' + door.label + '.' } : { type: 'overlap', itemId: a.id, otherId: b.id, message: a.label + ' overlaps ' + b.label + '.' });
        } else if (clearance > 0 && a.kind !== 'door' && b.kind !== 'door' && a.kind !== 'rug' && b.kind !== 'rug') {
          var distance = Infinity;
          first.polygons.forEach(function (ap) { second.polygons.forEach(function (bp) { distance = Math.min(distance, polygonDistance(ap, bp)); }); });
          if (distance < clearance - EPS) warnings.push({ type: 'clearance', itemId: a.id, otherId: b.id, message: a.label + ' and ' + b.label + ' have less than ' + format(clearance, plan.unit) + ' between their footprints. Check the space you need.' });
        }
      }
    }
    return warnings;
  }
  function newPlan(preset) {
    preset = preset || 'living';
    if (!presets.some(function (entry) { return entry.key === preset; })) fail('Unknown room preset.');
    var plan = { version: 1, name: 'My room plan', unit: 'in', room: { shape: 'rectangle', width: 240, depth: 180, cutWidth: 0, cutDepth: 0 }, items: [] };
    function add(key, x, y, rotation) {
      var source = catalog.filter(function (entry) { return entry.key === key; })[0];
      var item = clone(source);
      delete item.key;
      item.id = uid(); item.x = x; item.y = y; item.rotation = rotation || 0; item.source = 'placeholder'; item.clearance = 0;
      plan.items.push(item);
    }
    if (preset === 'living' || preset === 'lshape') {
      if (preset === 'lshape') plan.room = { shape: 'l-shape', width: 240, depth: 216, cutWidth: 84, cutDepth: 84 };
      add('rug', preset === 'lshape' ? 94 : 106, 107, 90); add('sofa', 88, 36); add('coffee-table', 88, 100); add('chair', 181, 124, 270);
    } else if (preset === 'bedroom') {
      plan.room.width = 192; plan.room.depth = 192;
      add('bed', 96, 62); add('nightstand', 43, 32); add('nightstand', 149, 32); add('dresser', 96, 168);
    } else if (preset === 'dining') {
      plan.room.width = 180; plan.room.depth = 168;
      add('dining-table', 90, 84); add('dining-chair', 90, 42); add('dining-chair', 90, 126, 180); add('dining-chair', 32, 84, 270); add('dining-chair', 148, 84, 90);
    }
    return validatePlan(plan);
  }
  return {
    version: 1, presets: presets, catalog: catalog, newPlan: newPlan,
    roomPolygon: roomPolygon, itemPolygons: itemPolygons, analyze: analyze,
    validatePlan: validatePlan, serialize: serialize, deserialize: deserialize,
    format: format, fromDisplay: fromDisplay, toDisplay: toDisplay, clone: clone, uid: uid
  };
}));
